import {Plan} from './plan.model';
import {Comercio} from './comercio.model';

export class Autorizacion {
	public id: number;
	public tipoCredito: number;
	public reporteRecienteAprobado: boolean;
	public montoMaximo: number;
	public planSeleccionado: Plan;
	public comercio: Comercio;
	public montoSolicitado: number;
	public productoAdquirido: string;
	public acceptedUnderCommerceRiskDate: Date;
	public underCommerceRisk: boolean;
	public isTypeDNI: boolean;
	public isTypeWithIngresos: boolean;
	public serviciosRequeridos: number;
}
